<template>
  <div>
    <p v-if="order.orderHistoryType === 'cancelled'">Avbestilt {{ $moment(order.updatedTime).format("DD.M.YYYY HH:mm") }}</p>
    <div class="d-flex justify-space-between align-center">
        <p class="profile__container--content__orderhistory--details-price__order-title">
          {{ order.siteName }}
        </p>
      </div>
    <div
      v-for="treatment in treatmentsOrder"
      :key="treatment.treatmentIdBase64"
    >
      <div class="d-flex align-center justify-space-between pb-3">
        <div class="profile__container--content__orderhistory--details">
          <v-hover v-slot="{ hover }"
            ><p
              class="font-weight-bold"
              :style="
                hover ? 'cursor: pointer; text-decoration: underline' : ''
              "
              @click="redirectTreatment(treatment)"
            >
              {{ treatment.treatmentName }}
            </p></v-hover
          >
          <p :style="
              (isCancelled && !isFutureButNotYetPaid)
                ? 'text-decoration: line-through;'
                : ''
            ">{{ Math.round(treatment.onlineTreatmentTime) }} min</p>
          <p
            :style="
              (isCancelled && !isFutureButNotYetPaid)
                ? 'text-decoration: line-through;'
                : ''
            "
          >
            <v-hover v-slot="{ hover }"
              ><span
                class="font-weight-bold"
                :style="
                  hover && treatment.employeeName
                    ? 'cursor: pointer; text-decoration: underline;'
                    : ''
                "
                @click="
                  treatment.employeeName ? redirectEmployee(treatment) : null
                "
                >{{
                  treatment.employeeName
                    ? treatment.employeeName
                    : "Første ledige"
                }}:</span
              ></v-hover
            >
            {{ $moment(order.appointmentDate).format("DD.MM.YYYY")
            }}{{
              treatment.treatmentStartTime && treatment.treatmentEndTime
                ? `, kl ${$moment(treatment.treatmentStartTime).format(
                    "HH:mm"
                  )} - ${$moment(treatment.treatmentEndTime)
                    .add(1, "seconds")
                    .format("HH:mm")}`
                : ""
            }}
          </p>
        </div>
        <div
          class="profile__container--content__orderhistory--details-price d-flex align-center font-weight-bold"
        >
          <p
            v-if="order.orderHistoryType !== 'previous-visit'"
            class="profile__container--content__orderhistory--details-price__from mb-0"
          >
            Fra
          </p>
          <p
            class="mb-0"
            :style="
              (isCancelled && !isFutureButNotYetPaid)
                ? 'text-decoration: line-through;'
                : ''
            "
          >
            {{
              treatment.price
                ? treatment.price.toFixed(2).replace(".", ",")
                : "0,00"
            }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="order.donations.length" class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex">
        <p class="font-weight-bold mb-0 mr-2">
          Donasjon:
        </p>
        <p class="mb-0">
          {{ order.donations[0].donationTitle }}
        </p>
      </div>
      <div class="profile__container--content__orderhistory--details-price d-flex align-center font-weight-bold">
        <p class="mb-0 "
              :style="
                (isCancelled && !isFutureButNotYetPaid)
                  ? 'text-decoration: line-through;'
                  : ''
              ">
          {{ order.donations[0].donationAmount.toFixed(2).replace(".", ",")}}
        </p>
      </div>
    </div>
    <hr class="profile__container--content__orderhistory--producthistory__linebreak mb-3"/>
    <div class="d-flex align-center justify-space-between">
      <p class="mb-0 profile__container--content__orderhistory--details-price__title">Sum behandlinger</p>
      <div class="profile__container--content__orderhistory--details-price d-flex align-center font-weight-bold">
        <p v-if="order.orderHistoryType !== 'previous-visit'" class="profile__container--content__orderhistory--details-price__from mb-0">Fra</p>
        <p class="mb-0" :style="(isCancelled && !isFutureButNotYetPaid) ? 'text-decoration: line-through;' : ''">
          {{ treatmentsTotalPrice.toFixed(2).replace(".", ",") }}
        </p>
      </div>
    </div>
    <p v-if="!order.products.length && order.paymentMethod && !(isCancelled && !isFutureButNotYetPaid)" class="mt-4"><b>Betalingsmetode:</b> {{order.paymentMethod}}</p>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
      default: {},
      type: Object,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  computed: {
    treatmentsOrder() {
      return this.order.treatments;
    },
    treatmentsTotalPrice() {
      let donationSum = 0
      if (this.order.donations.length) {
        donationSum += this.order.donations.map(x => x.donationAmount).reduce((partialSum, d) => {return partialSum + d}, 0)
      }
      return this.order.treatments
        .map((x) => x.price)
        .reduce((partialSum, a) => partialSum + a, 0) + donationSum;
    },
    isCancelled() {
      return this.order.orderHistoryType === 'cancelled'
    },
    isFutureButNotYetPaid() { //For x timer siden
      return (['future-visit', 'noshow', 'cancelled'].includes(this.order.orderHistoryType) && this.order.fairPayStatus === 'NEW')
    },
  },
  methods: {
    redirectEmployee(treatment) {
      this.$emit("close-profile");
      this.layout == "portal"
        ? window.open(
            `${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${
              this.order.siteId
            }/ansatt/${treatment.urlSafeEmployeeName}/${treatment.base64EmployeeId}`,
            "_self"
          )
        : this.$router.replace(
            `/about/${this.order.urlSafeSiteName}/${treatment.base64EmployeeId}`
          );
    },
    redirectTreatment(treatment) {
      this.$emit("close-profile");
      this.layout == "portal"
        ? window.open(
            `${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${this.order.urlSafeSiteName}/${
              this.order.siteId
            }/behandlinger/${treatment.urlSafeTreatmentName}/${treatment.base64TreatmentId}`,
            "_self"
          )
        : this.$router.replace(
            `/behandlinger/${treatment.urlSafeTreatmentName}/${treatment.base64TreatmentId}`
          );
    },
  },
};
</script>
